<template>
  <v-list-tile class="playable-item">
    <v-list-tile-avatar tile :class="{'cursor-pointer': routable, 'playable-avatar': true}"
                        @click="handleClickPlayable">
      <img :src="data.project.icon_url" />
    </v-list-tile-avatar>
    <v-list-tile-content :class="{'cursor-pointer': routable}" @click="handleClickPlayable">
      <v-list-tile-title>
        <div>
          <playable-screenshot v-if="!hideScreenshot" :data="data"></playable-screenshot>
        </div>
        <span>{{data.name}}</span>
      </v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action class="playable-play">
      <v-btn color="success" :href="playLink" target="_blank" depressed>Play</v-btn>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import PlayableAvatar from '@/components/BasePlayableAvatar.vue'
import MobileDetect from 'mobile-detect'
import PlayableScreenshot from './PlayableScreenshot.vue'

export default {
  name: 'playables-list-item',
  props: {
    data: Object,
    routable: {
      type: Boolean,
      default: false
    },
    hideScreenshot: {
      type: Boolean,
      default: false,
    }
  },
  components: { PlayableScreenshot, PlayableAvatar },
  data () {
    return {
      deviceData: new MobileDetect(window.navigator.userAgent)
    }
  },
  computed: {
    playLink () {
      return !this.deviceData.mobile() && this.data.device_url
        ? this.data.device_url
        : this.data.url
    }
  },
  methods: {
    handleClickPlayable () {
      if (!this.routable) return
      this.$router.push({
        name: 'Playable',
        params: {
          playable_id: this.data.id
        }
      })
    }
  }
}
</script>

<style>
  .playable-item {
    height: 100px;
    padding: 15px 10px;
  }

  .playable-item .v-list__tile__title {
    display: flex;
    height: 72px;
    vertical-align: top;
    align-items: top;
  }

  .playable-avatar {
    height: 72px;
  }

  .playable-play {
    height: 72px;
  }

  @media all and (max-width: 500px) {
    .playable-item .v-list__tile__title {
      height: 49px;
    }

    .playable-item .v-list__tile {
      height: 49px;
    }

    .playable-avatar {
      height: 49px;
    }

    .playable-play {
      height: 30px;
    }

    .playable-item {
      height: 80px;
    }
  }
</style>
